import { Assessment } from '../../../../types/assessment';

export class FetchAssessmentListAction {
  static readonly type = '[Assessment List action] fetch list';
  constructor(public therapistID: string) {}
}

export class AddAssessmentAction {
  static readonly type = '[Add Assessment action] add assessment';
  constructor(public assessment: Assessment) {}
}
